export default __webpack_public_path__ + "static/media/download.24b9a153.svg";